import type { ScreenModule } from "../../../app/screen-module";
import { SignupPage } from "../auth-pages";

export default {
	id: "public.signup",
	path: "/signup",
	area: "public",
	label: "新規登録",
	roles: [],
	backing: "ZEROVIA",
	enabled: true,
	component: SignupPage,
} satisfies ScreenModule;
